<template>
    <v-dialog v-model="value" scrollable persistent max-width="400px">
        <v-form ref="editForm" method="post" :action="action" @success="editSuccess">
            <input type="hidden" name="id" v-model="contact.id"/>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{formTitle}}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="$emit('input', false)">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider />
                <v-card-text class="v-dialog-body">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    type="text"
                                    name="name"
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    :error-messages="errors.name"
                                    :label="$t('contact.name')"
                                    append-icon="person"
                                    v-model="contact.name"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>

                                <v-text-field
                                    v-model="contact.areaCode"
                                    prefix="+"
                                    :label="$t('contact.area_code')"
                                    :rules="[rules.required]"
                                    :readonly="contact.id > 0"
                                    :box="contact.id > 0"
                                    name="area_code"
                                >
                                </v-text-field>

                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    type="text"
                                    name="phone"
                                    maxlength="50"
                                    :label="$t('contact.phone')"
                                    append-icon="phone"
                                    :rules="[rules.required]"
                                    :error-messages="errors.phone"
                                    :readonly="contact.id > 0"
                                    :box="contact.id > 0"
                                    v-model="contact.phone"
                                    :mask="phoneMask"
                                >
                                </v-text-field>
                            </v-flex>
                            <template v-if="group_list.length">
                                <v-flex xs12>
                                    <v-autocomplete
                                            v-model="contact.group_ids"
                                            :items="group_list"
                                            item-text="name"
                                            item-value="id"
                                            chips
                                            deletable-chips
                                            :label="$t('contact.contact_groups')"
                                            multiple
                                    />
                                    <input type="hidden" name="groups" :value="contact.group_ids">
                                </v-flex>
                            </template>

                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.close')}}</v-btn>
                    <v-btn color="blue darken-1" flat
                           type="submit"
                           ref="submit"
                           :loading="loading"
                    >
                        {{$t('action.save')}}
                    </v-btn>
                    <!--<v-btn color="primary" type="submit" ref="submit" flat :loading="loading">{{$t('form.submit')}}</v-btn>-->
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {UrlServices} from '~/utils/url-manager'
    import FormHandling from '~/utils/data/form-handling'
    import RequestHandler from "~/utils/request-handler";
    export default {
        props: {
            value: Boolean,
            item: Object,
        },
        data() {
            return {
                contact: {
                    id: 0,
                    name: '',
                    areaCode: '852',
                    phone: '',
                    group_ids: []
                },
                action: UrlServices.createUrl({'name': 'api_contact_save'}),
                loading: false,
                areaCodes: ['852'],
                phoneMask: '#'.repeat(50),
                group_list: [],
                rules: {
                    required: value => !!value || this.$t('form.field_required')
                },
                errors: {
                    name: '',
                    phone: ''
                }
            }
        },
        watch: {
            item: function() {
                this.item.areaCode = this.item.areaCode.replace('+', '');
                let group_ids = [];
                _.each(this.item.contact_groups, function(item){
                    group_ids.push(item['id']);
                });
                this.item.group_ids = group_ids;
                this.contact = _.extend({}, this.item);
            }
        },
        computed: {
            formTitle () {
                return (this.contact.id > 0) ? this.$t('contact.edit_contact') : this.$t('contact.new_contact');
            }
        },
        methods: {
            editSuccess(data) {
                this.$emit('success', data);
            },
            getGroupList() {
                let me = this;
                RequestHandler.Get(UrlServices.createUrl({'name': 'api_contact_group_name_list'}), {}, {
                    'success': function(data){
                        me.group_list = data;
                    }
                });
            },
        },
        mounted() {
            this.getGroupList();
            new FormHandling(this, "editForm");
        }
    }
</script>